import { render, staticRenderFns } from "./ContextMenu.vue?vue&type=template&id=27ae3e8b&"
import script from "./ContextMenu.vue?vue&type=script&lang=js&"
export * from "./ContextMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/danford/drochat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27ae3e8b')) {
      api.createRecord('27ae3e8b', component.options)
    } else {
      api.reload('27ae3e8b', component.options)
    }
    module.hot.accept("./ContextMenu.vue?vue&type=template&id=27ae3e8b&", function () {
      api.rerender('27ae3e8b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/ui/ContextMenu.vue"
export default component.exports